import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDown } from "lucide-react";

const LineReveal = ({ children, delay }) => (
  <span className="block overflow-hidden">
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const Hero = () => {
  const { scrollY } = useScroll();
  const yBg = useTransform(scrollY, [0, 800], [0, 180]);

  return (
    <section id="top" className="relative min-h-screen flex items-end overflow-hidden grain">
      <motion.div style={{ y: yBg }} className="absolute inset-0 -z-10" aria-hidden="true">
        <img
          src="https://images.pexels.com/photos/4880794/pexels-photo-4880794.jpeg"
          alt=""
          className="w-full h-[120%] object-cover opacity-45"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#FBF7EE] via-[#FBF7EE]/60 to-[#FBF7EE]/15" />
        <div className="absolute -bottom-40 -right-40 w-[36rem] h-[36rem] rounded-full bg-[#1B4332]/15 blur-[140px]" />
      </motion.div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 pb-24 pt-40 w-full">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
          className="font-mono text-xs uppercase tracking-[0.35em] text-[#A67C1E] mb-8"
          data-testid="hero-overline"
        >
          Kurasi Produk Digital Premium
        </motion.p>

        <h1 className="font-display tracking-tighter text-[#211B10] text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-4xl">
          <LineReveal delay={0.4}>Ubah pola pikir Anda,</LineReveal>
          <LineReveal delay={0.55}>
            maka <em className="text-[#A67C1E] not-italic font-display italic">kelimpahan</em> akan
          </LineReveal>
          <LineReveal delay={0.7}>mengikuti dengan sendirinya.</LineReveal>
        </h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 1 }}
          className="mt-8 max-w-xl text-base md:text-lg text-[#211B10]/65 leading-relaxed"
        >
          Kami mengkurasi program digital terbaik untuk transformasi finansial dan pola pikir.
          Setiap pembelian diproses aman melalui platform resmi — Anda tinggal memilih, klik, dan mulai berubah hari ini.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 1.2 }}
          className="mt-10 flex flex-wrap items-center gap-6"
        >
          <a
            data-testid="hero-cta-button"
            href="#produk"
            className="inline-flex items-center gap-3 bg-[#A67C1E] text-[#FBF7EE] font-medium text-sm uppercase tracking-[0.15em] px-8 py-4 hover:bg-[#211B10] hover:-translate-y-1 transition-[background-color,transform] duration-300"
          >
            Jelajahi Koleksi
            <ArrowDown className="w-4 h-4" />
          </a>
          <a
            data-testid="hero-secondary-link"
            href="#manifesto"
            className="font-mono text-xs uppercase tracking-[0.2em] text-[#211B10]/60 hover:text-[#A67C1E] transition-colors border-b border-[#211B10]/20 hover:border-[#A67C1E] pb-1"
          >
            Baca Manifesto Kami
          </a>
        </motion.div>
      </div>
    </section>
  );
};
